export default "__VITE_ASSET__BfMSaleF__"